






























import { isArray } from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BuilderTooltip extends Vue {
  @Prop({ default: true, type: Boolean }) private loaded!: boolean
  @Prop({ default: false, type: Boolean }) private absolute!: boolean

  @Prop({ required: true, type: [String, Number] }) private step!: string | number

  @Prop({ default: 0, type: [String, Number, Array] }) private position!: string | number | []

  @Prop({ default: 'menu-bevel', type: String }) private iconTopRight!: string | null

  @Prop({ default: true, type: Boolean }) private isClickedShowMenu!: boolean
  @Prop({ default: false, type: Boolean }) isGpt!: boolean

  get formattedPosition(): number {
    return Number(this.position) * 2
  }
  get isTop() {
    return Array.isArray(this.position)
  }
  get style() {
    if (this.isTop) {
      return `top: ${this.position[1]}px`
    }
    if (this.absolute) {
      return `bottom: ${this.position}px`
    }
    return `margin-top: ${this.formattedPosition}px`
  }

  get formattedStep(): string {
    return String(this.step).padStart(2, '0')
  }
  async handlerClickBtnIconTop(): Promise<void> {
    if (this.isClickedShowMenu) {
      await this.$store.dispatch('app/changeVisibilityMenu', true)
      return
    }
    this.$emit('click-icon')
  }
}
